import { render, staticRenderFns } from "./ClipboardIcon.vue?vue&type=template&id=63171ddb"
import script from "./ClipboardIcon.vue?vue&type=script&lang=ts"
export * from "./ClipboardIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports